import { Alert, AlertIcon, AlertProps, AlertTitle, AlertDescription } from '@chakra-ui/react';
import { FC } from 'react';

type Props = AlertProps & {
  message: string;
  style?: any; // TODO
}

export const AlertError: FC<Props> = ({ title, message, style }) => (
  <Alert status="error" style={ style } fontSize={"sm"} py={2} px={4} borderRadius={"sm"}>
    <AlertIcon boxSize={4} />
    {title ? <AlertTitle>{ title }</AlertTitle> : null}
    <AlertDescription>{ message }</AlertDescription>
  </Alert>
);
